module.exports = __webpack_public_path__ + "static/img/list-img2.3cfa024.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list-img2.png
// module id = Rc7G
// module chunks = 0